import { useCallback } from "react";

/** How far below the viewport the marker sits when the next page starts loading, so it lands before the patient reaches the end. */
export const LOAD_AHEAD_MARGIN = "0px 0px 800px 0px";

/**
 * An invisible marker at the end of a list that calls `onVisible` once, as it comes within
 * `LOAD_AHEAD_MARGIN` of the viewport. Key it by how many items are loaded so each new page arms it again.
 */
export const LoadMoreOnScroll = ({ onVisible }: { onVisible: () => void }) => {
  const observe = useCallback(
    (element: HTMLDivElement | null) => {
      if (!element) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry?.isIntersecting) return;
          observer.disconnect();
          onVisible();
        },
        { rootMargin: LOAD_AHEAD_MARGIN },
      );
      observer.observe(element);
      return () => observer.disconnect();
    },
    [onVisible],
  );

  return (
    <div ref={observe} aria-hidden="true" data-testid="load-more-on-scroll" className="h-px" />
  );
};
